import commonApi from '@/api/common.api.js';
import { Loading } from 'element-ui';
/**
 * 文件上传Mixin
 */
export default {
    data () {
        return {
            oneUpload: null,
            fileUrl: null,
            fileBase64: null
        };
    },
    methods: {
        /**
         * 上传
         */
        async getFileUrl (file) {
            this.oneUpload = file;
            if (this.oneUpload.size / 1024 / 1024 / 100 < 1) {
                let loadingInstance = Loading.service();
                try {
                    let res = await this.getBase64(file.raw || file);

                    var base64String = res.substring(res.indexOf(',') + 1);
                    let fileName = Date.now() + '.' + file.name.substring(file.name.lastIndexOf('.') + 1);
                    let payload = {
                        'fileContent': base64String,
                        'fileContentType': '',
                        'fileName': fileName
                    };
                    this.fileBase64 = res;
                    let url = this.fileUrl = await commonApi.upload(payload);
                    loadingInstance.close();
                    return url;
                } catch (error) {
                    this.$message.error('上传失败');
                    loadingInstance.close();
                    throw error;
                }
            } else {
                this.$message.error('上传图片的大小不能大于100M');
            }
        },

        /**
         * 文件转base64
         */
        getBase64 (file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                let fileResult = '';
                reader.readAsDataURL(file);
                reader.onload = () => {
                    fileResult = reader.result;
                };
                reader.onerror = (error) => {
                    reject(error);
                };
                reader.onloadend = () => {
                    resolve(fileResult);
                };
            });
        },

        /**
         * 删除文件
         */
        delFile () {
            this.oneUpload = null;
            this.fileUrl = '';
        }
    }
};
